<script>
  import Header from '@/components/templates/Header'
  import Sugoroku from '@/components/templates/Sugoroku'
  import Achivement from '@/components/templates/Achivement'
  import HimekuriCalendar from '@/components/templates/HimekuriCalendar'
  import Footer from '@/components/templates/Footer'
  import ModalCheckPoint from '@/components/templates/ModalCheckPoint'
  import ModalIntro from '@/components/templates/ModalIntro'
  import ModalStamp from '@/components/templates/ModalStamp'
  import ModalRegulation from '@/components/templates/ModalRegulation'
  import Answers from '@/components/templates/Answers'
  import store from './store'
  import { differenceInSeconds } from 'date-fns';

  export default {
    store,
    name: 'App',
    components: {
      Header,
      Sugoroku,
      Achivement,
      HimekuriCalendar,
      Footer,
      ModalCheckPoint,
      ModalIntro,
      ModalStamp,
      ModalRegulation,
      Answers,
    },
    data() {
      return {
        isView: false,
        isExpired: false,
        lastDate: new Date(2020, 2, 17, 0, 0),
      }
    },
    mounted() {
      const lastAnswerDateNum = 5;
      if(!(differenceInSeconds(new Date(), this.lastDate) > 0)) {
        if (this.$store.state.diffInDays >= lastAnswerDateNum || this.$store.state.answeredIds.length < 1) {
          this.$store.commit('toggleModalIntro', true);
        } 
      }
    },
    methods: {
      textExpired() {
        this.isExpired = true;
      }
    }
  }
</script>

<template lang="pug">
  div
    .main
      Header
      .main__content
        .main__sugoroku
          Sugoroku
          Achivement
        .main__himekuri
          HimekuriCalendar(
            :isExpired = 'isExpired'
            )
      .main__answers
        Answers(
          :isExpired = 'isExpired'
          )
    .sub
      Footer
    ModalIntro
    ModalCheckPoint
    ModalStamp
    ModalRegulation
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,500,700&display=swap&subset=japanese');
  @import '@/assets/css/foundation/ress.scss';
  @import '@/assets/css/foundation/base.scss';

  .main {
    background-color: $base-color;
    @include l-more-than-mobile {
      padding-top: 40px;
      border-top: 5px solid $primary-color;
    }
    @include l-mobile {
      padding-top: 11px;
    }
    &__content {
      @include l-more-than-mobile {
        width: 1000px;
        height: 515px;
        position: relative;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 40px;
      }
    }
    &__sugoroku {
      @include l-more-than-mobile {
        width: 500px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        transform: translate3d(0, 0, 0);
      }
      @include l-mobile {
        position: relative;
        margin-top: -70 / 375 * 100%;
        z-index: 1;
        transform: translate3d(0, 0, 0);
      }
    }
    &__himekuri {
      box-sizing: border-box;
      background-color: $primary-color;
      @include l-more-than-mobile {
        width: 460px;
        position: absolute;
        bottom: 0;
        right: 0;
        padding-top: 41px;
        padding-bottom: 41px;
        border-radius: 8px;
      }
      @include l-mobile {
      }
    }
    &__answers {
      margin-top: 0;
      overflow: hidden;
      @include l-mobile {
        background-color: $primary-color;
      }
    }
  }
  .sub {
    padding-top: 17px;
    padding-bottom: 17px;
    background-color: $primary-color;
    @include l-more-than-mobile {
      padding-right: 40px;
      padding-left: 40px;
    }
  }

  // test
  .main {
    &__himekuri-btn {
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 4px;
      border-radius: 28px;
      @include fontSize(15);
      font-weight: bold;
      background-color: $base-color;
      color: $primary-color;
      border: 3px solid $primary-color;
      @include l-more-than-mobile {
        height: 30px;
        width: 300px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: -30px;
      }
      @include l-mobile {
        height: 40px;
        width: 100%;
      }
    }
  }
</style>
